import request from '@/utils/request';


// 用户收货地址列表
export function adressList(params, pageNum, pageSize) {
         return request({
           url: '/wx/address/listpage',
           method: 'get',
           params: { params, pageNum, pageSize },
         });
       }
// 保存用户收货地址
export function saveAdress(data) {
    return request({
        url: '/wx/address/save',
        method: 'post',
        data: data,
    })
}
// 删除用户收货地址
export function deleteAdress(data) {
    return request({
        url: '/wx/address/delete',
        method: 'post',
        data: data,
    })
}

// 用户收货地址详情
export function detailAdress(id) {
    return request({
        url: '/wx/address/detail',
        method: 'get',
        params: { id }
    })
}




// WEBPACK FOOTER //
// ./src/api/adress/adress.js